/** Public client configuration. The publishable key is safe to ship in the browser; data
 *  access is enforced by Row Level Security. Override with VITE_* variables at build time. */
export const SUPABASE_URL: string =
  import.meta.env.VITE_SUPABASE_URL ?? 'https://anvvlzicczulpffqsvdn.supabase.co';

export const SUPABASE_PUBLISHABLE_KEY: string =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? 'sb_publishable_gbjlqTVnh2s_nMk_QisD0w_8hVa8ITa';
